import React from "react";
import IconChevronRight from "ReactComponents/Shared/Icons/icon-chevron-right";

export interface IProductMediaLinkWithCallbackProps {
    label: string;
    icon: JSX.Element;
    onClick: () => void;
}

const ProductMediaLinkWithCallback = ({ label, icon, onClick }: IProductMediaLinkWithCallbackProps) => {
    return (
        <button onClick={onClick} className="product-media-link" type="button">
            {icon}
            <div className="product-media-link__text">{label}</div>
            <IconChevronRight />
        </button>
    );
};

export default ProductMediaLinkWithCallback;
